/** @format */

import {CssBaseline} from '@mui/material';

import {TopMenuNew} from 'components/menus/TopMenuNew';
import {NoDataBannerNew} from 'components/banners/NoDataBannerNew';
import PaymentErrorBanner from 'components/banners/PaymentErrorBanner';

import ChatBreadcrumbs from '../ChatBreadcrumbs';
import {LayoutRoot, MenuBox, BreadcrumbsContainer, ContentContainer} from './styles';

interface ChatLayoutProps {
  companyId: string;
  companyName: string;
  sidebar: React.ReactNode;
  children: React.ReactNode;
}

const ChatLayout = ({companyId, companyName, sidebar, children}: ChatLayoutProps) => {
  return (
    <LayoutRoot>
      <CssBaseline />
      <MenuBox>
        <TopMenuNew />
      </MenuBox>
      <NoDataBannerNew />
      <PaymentErrorBanner />
      <BreadcrumbsContainer>
        <ChatBreadcrumbs companyId={companyId} companyName={companyName} />
      </BreadcrumbsContainer>
      <ContentContainer>
        {sidebar}
        {children}
      </ContentContainer>
    </LayoutRoot>
  );
};

export default ChatLayout;
